import { Button, Group } from '@mantine/core';

type ClientFamilyToggleProps = {
  isFamily: boolean;
  onToggle: (isFamily: boolean) => void;
};

export function ClientFamilyToggle({ isFamily, onToggle }: ClientFamilyToggleProps) {
  return (
    <Group justify="space-between" mb="sm">
      <Button.Group>
        <Button variant={isFamily ? 'subtle' : 'light'} onClick={() => onToggle(false)}>
          Clients
        </Button>
        <Button variant={isFamily ? 'light' : 'subtle'} onClick={() => onToggle(true)}>
          Families
        </Button>
      </Button.Group>
    </Group>
  );
}
